// Standardized toast configurations
export const createToast = (toast) => ({
  success: (message, description) =>
    toast({
      title: message,
      description,
      status: "success",
      duration: 3000,
      isClosable: true,
    }),

  error: (message, description) =>
    toast({
      title: message,
      description,
      status: "error",
      duration: 5000,
      isClosable: true,
    }),

  info: (message, description) =>
    toast({
      title: message,
      description,
      status: "info",
      duration: 3000,
      isClosable: true,
    }),

  loading: (message, description) =>
    toast({
      title: message,
      description,
      status: "info",
      duration: 1000,
      isClosable: false,
    }),
});
